import type { EditablePath, EditorPoint } from './path-editor';

/** Hit anchor centers against the capsule swept by an eraser between events.
 * A continuous segment prevents fast drags from skipping anchors between frames.
 * The caller supplies source-space radius so the cursor can stay screen-sized.
 */
export function hitEditableNodesAlongSweep(paths: readonly EditablePath[], from: EditorPoint, to: EditorPoint, radius: number): Set<string> {
  if (![from.x, from.y, to.x, to.y, radius].every(Number.isFinite) || radius < 0) throw new Error('Invalid editor eraser sweep');
  const hit = new Set<string>();
  const dx = to.x - from.x, dy = to.y - from.y, length2 = dx * dx + dy * dy, radius2 = radius * radius;
  const minX = Math.min(from.x, to.x) - radius, maxX = Math.max(from.x, to.x) + radius;
  const minY = Math.min(from.y, to.y) - radius, maxY = Math.max(from.y, to.y) + radius;
  for (const path of paths) for (const subpath of path.subpaths) for (const node of subpath.nodes) {
    const p = node.point;
    if (p.x < minX || p.x > maxX || p.y < minY || p.y > maxY) continue;
    const t = length2 ? Math.max(0, Math.min(1, ((p.x - from.x) * dx + (p.y - from.y) * dy) / length2)) : 0;
    const x = p.x - from.x - dx * t, y = p.y - from.y - dy * t;
    if (x * x + y * y <= radius2) hit.add(node.id);
  }
  return hit;
}
